import { TransportSubMode } from '../models/transport-sub-mode.enum';
import { TranslationService } from '../services/translation.service';

export const pseudoTransportSubModeOtherTrains: string = 'otherTrains';

const translationDictionary = [
  { transportMode: TransportSubMode.vasttagen, translationKey: 'common.vasttagen' },
  { transportMode: TransportSubMode.regionalTrain, translationKey: 'common.regionaltrain' },
  { transportMode: TransportSubMode.longDistanceTrain, translationKey: 'common.longdistancetrain' },
  { transportMode: pseudoTransportSubModeOtherTrains, translationKey: 'common.othertrains' },
];

export class TransportSubModeHelper {
  public static parse(value: string): TransportSubMode {
    if (Object.values(TransportSubMode).includes(value as TransportSubMode)) {
      return value as TransportSubMode;
    }
    return TransportSubMode.unknown;
  }

  public static translate(value: string): string {
    if (!value) {
      return '';
    }
    if (translationDictionary.findIndex((obj) => obj.transportMode === value) < 0) {
      return value;
    }

    let result = '';
    const translationKeyValue = translationDictionary.find((obj) => obj.transportMode === value);
    if (translationKeyValue) {
      result = TranslationService.get(translationKeyValue.translationKey);
    }

    return result;
  }
}
